export class Credentials {
    UserName: string;
    Password: string;
    DomainAccountName: string;
    MfaSecret: string;
}